type DefaultProductDataType = { [key: string]: ProductData };
type ProductData = {
	products: ProductSubData[];
	bundleProductKeys: string;
	bundleContent?: BundleContent;
};
type ProductSubData = {
	productKey: string;
	productName: string;
	productLogoUrl: string;
	productLogoWhiteUrl?: string;
};
type BundleContent = {
	default: BundleData;
};
type BundleData = {
	heroImage: string;
	headline: string;
	socialProofImage: string;
	featureList: string;
};

export const defaultProductData: DefaultProductDataType = {
	default: {
		products: [
			{
				productKey: 'jira-software.ondemand',
				productName: 'Jira Software',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg',
			},
		],
		bundleProductKeys: 'jira-software.ondemand',
		bundleContent: {
			default: {
				heroImage:
					'https://atlassian.com/dam/jcr:0c7fa8be-146c-4c6f-84de-de9fb3b84674/Jira%20Hero.svg',
				headline: 'Bundle Headline',
				socialProofImage:
					'https://atlassian.com/dam/jcr:f91dc7b8-ec95-4ae5-91e3-d5f6acc169dd/Jira%20Logo.svg',
				featureList:
					'<ul> <li>Access all features</li> <li>Scale agile practices</li> <li>Consolidate workflows</li> <li>Plan, track, and release</li> </ul> ',
			},
		},
	},
	'jira-software-confluence': {
		products: [
			{
				productKey: 'jira-software.ondemand',
				productName: 'Jira Software',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg',
			},
			{
				productKey: 'confluence.ondemand',
				productName: 'Confluence',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg',
			},
		],
		bundleProductKeys: 'jira-software.ondemand,confluence.ondemand',
	},
	'jira-software-confluence-compass': {
		products: [
			{
				productKey: 'jira-software.ondemand',
				productName: 'Jira Software',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg',
			},
			{
				productKey: 'confluence.ondemand',
				productName: 'Confluence',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg',
			},
			{
				productKey: 'compass',
				productName: 'Compass',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:d1f2bb70-4bce-48a4-ae05-f83adb30ac58/Avocado.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:d1f2bb70-4bce-48a4-ae05-f83adb30ac58/Avocado.svg',
			},
		],
		bundleProductKeys: 'jira-software.ondemand,confluence.ondemand,compass',
	},
	'jira-software-jira-service-desk-confluence': {
		products: [
			{
				productKey: 'jira-software.ondemand',
				productName: 'Jira Software',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg',
			},
			{
				productKey: 'jira-servicedesk.ondemand',
				productName: 'Jira Service Management',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg',
			},
			{
				productKey: 'confluence.ondemand',
				productName: 'Confluence',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg',
			},
		],
		bundleProductKeys: 'jira-software.ondemand,jira-servicedesk.ondemand,confluence.ondemand',
	},
	'jira-software-jira-service-management-confluence': {
		products: [
			{
				productKey: 'jira-software.ondemand',
				productName: 'Jira Software',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg',
			},
			{
				productKey: 'jira-servicedesk.ondemand',
				productName: 'Jira Service Management',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg',
			},
			{
				productKey: 'confluence.ondemand',
				productName: 'Confluence',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg',
			},
		],
		bundleProductKeys: 'jira-software.ondemand,jira-servicedesk.ondemand,confluence.ondemand',
	},
	'jira-software-jira-service-desk': {
		products: [
			{
				productKey: 'jira-software.ondemand',
				productName: 'Jira Software',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg',
			},
			{
				productKey: 'jira-servicedesk.ondemand',
				productName: 'Jira Service Management',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg',
			},
		],
		bundleProductKeys: 'jira-software.ondemand,jira-servicedesk.ondemand',
	},
	'jira-service-desk-jira-software': {
		products: [
			{
				productKey: 'jira-servicedesk.ondemand',
				productName: 'Jira Service Management',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg',
			},
			{
				productKey: 'jira-software.ondemand',
				productName: 'Jira Software',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg',
			},
		],
		bundleProductKeys: 'jira-servicedesk.ondemand,jira-software.ondemand',
	},
	'jira-service-management-jira-software': {
		products: [
			{
				productKey: 'jira-servicedesk.ondemand',
				productName: 'Jira Service Management',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg',
			},
			{
				productKey: 'jira-software.ondemand',
				productName: 'Jira Software',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg',
			},
		],
		bundleProductKeys: 'jira-servicedesk.ondemand,jira-software.ondemand',
	},
	'jira-software-jira-service-management': {
		products: [
			{
				productKey: 'jira-software.ondemand',
				productName: 'Jira Software',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg',
			},
			{
				productKey: 'jira-servicedesk.ondemand',
				productName: 'Jira Service Management',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg',
			},
		],
		bundleProductKeys: 'jira-software.ondemand,jira-servicedesk.ondemand',
	},
	'jira-service-desk-jira-software-confluence': {
		products: [
			{
				productKey: 'jira-servicedesk.ondemand',
				productName: 'Jira Service Management',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg',
			},
			{
				productKey: 'jira-software.ondemand',
				productName: 'Jira Software',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg',
			},
			{
				productKey: 'confluence.ondemand',
				productName: 'Confluence',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg',
			},
		],
		bundleProductKeys: 'jira-servicedesk.ondemand,jira-software.ondemand,confluence.ondemand',
	},
	'jira-service-management-jira-software-confluence': {
		products: [
			{
				productKey: 'jira-servicedesk.ondemand',
				productName: 'Jira Service Management',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg',
			},
			{
				productKey: 'jira-software.ondemand',
				productName: 'Jira Software',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg',
			},
			{
				productKey: 'confluence.ondemand',
				productName: 'Confluence',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg',
			},
		],
		bundleProductKeys: 'jira-servicedesk.ondemand,jira-software.ondemand,confluence.ondemand',
	},
	'jira-software': {
		products: [
			{
				productKey: 'jira-software.ondemand',
				productName: 'Jira Software',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg',
			},
		],
		bundleProductKeys: 'jira-software.ondemand',
		bundleContent: {
			default: {
				heroImage:
					'https://atlassian.com/dam/jcr:0c7fa8be-146c-4c6f-84de-de9fb3b84674/Jira%20Hero.svg',
				headline: 'Bundle Headline',
				socialProofImage:
					'https://atlassian.com/dam/jcr:f91dc7b8-ec95-4ae5-91e3-d5f6acc169dd/Jira%20Logo.svg',
				featureList:
					'<ul> <li>Access all features</li> <li>Scale agile practices</li> <li>Consolidate workflows</li> <li>Plan, track, and release</li> </ul> ',
			},
		},
	},
	'jira-service-desk': {
		products: [
			{
				productKey: 'jira-servicedesk.ondemand',
				productName: 'Jira Service Management',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg',
			},
		],
		bundleProductKeys: 'jira-servicedesk.ondemand',
	},
	'jira-service-management': {
		products: [
			{
				productKey: 'jira-servicedesk.ondemand',
				productName: 'Jira Service Management',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg',
			},
		],
		bundleProductKeys: 'jira-servicedesk.ondemand',
	},
	'jira-service-desk-confluence': {
		products: [
			{
				productKey: 'jira-servicedesk.ondemand',
				productName: 'Jira Service Management',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg',
			},
			{
				productKey: 'confluence.ondemand',
				productName: 'Confluence',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg',
			},
		],
		bundleProductKeys: 'jira-servicedesk.ondemand,confluence.ondemand',
	},
	'jira-service-management-confluence': {
		products: [
			{
				productKey: 'jira-servicedesk.ondemand',
				productName: 'Jira Service Management',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg',
			},
			{
				productKey: 'confluence.ondemand',
				productName: 'Confluence',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg',
			},
		],
		bundleProductKeys: 'jira-servicedesk.ondemand,confluence.ondemand',
	},
	'jira-core-confluence': {
		products: [
			{
				productKey: 'jira-software.ondemand',
				productName: 'Jira Software',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg',
			},
			{
				productKey: 'confluence.ondemand',
				productName: 'Confluence',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg',
			},
		],
		bundleProductKeys: 'jira-software.ondemand,confluence.ondemand',
	},
	confluence: {
		products: [
			{
				productKey: 'confluence.ondemand',
				productName: 'Confluence',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg',
			},
		],
		bundleProductKeys: 'confluence.ondemand',
	},
	'confluence-jira-service-desk': {
		products: [
			{
				productKey: 'confluence.ondemand',
				productName: 'Confluence',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg',
			},
			{
				productKey: 'jira-servicedesk.ondemand',
				productName: 'Jira Service Management',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg',
			},
		],
		bundleProductKeys: 'confluence.ondemand,jira-servicedesk.ondemand',
	},
	'confluence-jira-service-management': {
		products: [
			{
				productKey: 'confluence.ondemand',
				productName: 'Confluence',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg',
			},
			{
				productKey: 'jira-servicedesk.ondemand',
				productName: 'Jira Service Management',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg',
			},
		],
		bundleProductKeys: 'confluence.ondemand,jira-servicedesk.ondemand',
	},
	developer: {
		products: [
			{
				productKey: 'confluence.ondemand',
				productName: 'Confluence',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg',
			},
			{
				productKey: 'jira-software.ondemand',
				productName: 'Jira Software',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg',
			},
			{
				productKey: 'com.atlassian.service-collection',
				productName: 'Service Collection',
				productLogoUrl:
					'https://dam-cdn.atl.orangelogic.com/AssetLink/171f20t4om07135ujka42le40wvkp613.svg',
			},
		],
		bundleProductKeys:
			'confluence.ondemand,jira-software.ondemand,com.atlassian.service-collection',
	},
	'confluence-jira-software': {
		products: [
			{
				productKey: 'confluence.ondemand',
				productName: 'Confluence',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg',
			},
			{
				productKey: 'jira-software.ondemand',
				productName: 'Jira Software',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg',
			},
		],
		bundleProductKeys: 'confluence.ondemand,jira-software.ondemand',
	},
	'jira-software-bitbucket': {
		products: [
			{
				productKey: 'jira-software.ondemand',
				productName: 'Jira Software',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg',
			},
		],
		bundleProductKeys: 'jira-software.ondemand',
	},
	'bitbucket-jira-software': {
		products: [
			{
				productKey: 'com.atlassian.bitbucket',
				productName: 'Bitbucket',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:bd56917e-e361-4f03-b672-9f5ef5b06e80/Bitbucket-blue.svg',
			},
		],
		bundleProductKeys: 'com.atlassian.bitbucket',
	},
	opsgenie: {
		products: [
			{
				productKey: 'opsgenie',
				productName: 'Opsgenie',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:5b512ce6-164b-42c2-a615-00ea3c38f132/Opsgenie-blue-rgb.svg',
			},
		],
		bundleProductKeys: 'opsgenie',
	},
	bitbucket: {
		products: [
			{
				productKey: 'com.atlassian.bitbucket',
				productName: 'Bitbucket',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:bd56917e-e361-4f03-b672-9f5ef5b06e80/Bitbucket-blue.svg',
			},
		],
		bundleProductKeys: 'com.atlassian.bitbucket',
	},
	statuspage: {
		products: [
			{
				productKey: 'statuspage',
				productName: 'Statuspage',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:d909aeb4-b62e-4f59-8cf3-dc611bed6564/Statuspage-blue.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:442a5960-4c84-4874-979e-3201b65f7e61/Statuspage-white.svg',
			},
		],
		bundleProductKeys: 'statuspage',
	},
	'team-central': {
		products: [
			{
				productKey: 'townsquare',
				productName: 'Team Central',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:3a87ab6e-771b-41ae-93fc-e7230641430c/atlas-beta-color.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:9c6be750-6612-4b30-acb2-1e2d6c1cea8f/atlas-logo-white.svg',
			},
		],
		bundleProductKeys: 'townsquare',
	},
	atlas: {
		products: [
			{
				productKey: 'townsquare',
				productName: 'Team Central',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:3a87ab6e-771b-41ae-93fc-e7230641430c/atlas-beta-color.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:9c6be750-6612-4b30-acb2-1e2d6c1cea8f/atlas-logo-white.svg',
			},
		],
		bundleProductKeys: 'townsquare',
	},
	beacon: {
		products: [
			{
				productKey: 'beacon',
				productName: 'Beacon',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:ab20c8a3-0ba6-436a-9a00-42873c776738/beacon-blue.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:563c3ec0-574d-4384-b60d-59987e5d83ee/beacon-white.svg',
			},
		],
		bundleProductKeys: 'beacon',
	},
	fabric: {
		products: [
			{
				productKey: 'atlassian-whiteboard',
				productName: 'Fabric',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:4fc54485-e365-4549-af5f-3610a970e5d2/Confluence_Whiteboards_logo_lockup_blue.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:13abb206-c43f-4d9e-9b76-631bcf9ae692/Confluence_Whiteboards_logo_lockup.svg',
			},
		],
		bundleProductKeys: 'atlassian-whiteboard',
	},
	compass: {
		products: [
			{
				productKey: 'compass',
				productName: 'Compass',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:d1f2bb70-4bce-48a4-ae05-f83adb30ac58/Avocado.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:d1f2bb70-4bce-48a4-ae05-f83adb30ac58/Avocado.svg',
			},
		],
		bundleProductKeys: 'compass',
	},
	'jira-software-compass-confluence-test': {
		products: [
			{
				productKey: 'jira-software.ondemand',
				productName: 'Jira Software',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg',
			},
			{
				productKey: 'compass',
				productName: 'Compass',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:d1f2bb70-4bce-48a4-ae05-f83adb30ac58/Avocado.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:d1f2bb70-4bce-48a4-ae05-f83adb30ac58/Avocado.svg',
			},
			{
				productKey: 'confluence.ondemand',
				productName: 'Confluence',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg',
			},
		],
		bundleProductKeys: 'jira-software.ondemand,compass,confluence.ondemand',
	},
	'jira-product-discovery': {
		products: [
			{
				productKey: 'jira-product-discovery',
				productName: 'Jira Product Discovery',
				productLogoUrl:
					'https://atlassian.com/dam/jcr:47be17fd-8047-4a14-bc38-c1ebbb80e037/Jira%20Product%20Discovery-logo-blue.svg',
				productLogoWhiteUrl:
					'https://atlassian.com/dam/jcr:2d01e092-097f-4417-875b-8997fecb2318/jpd-white.svg',
			},
		],
		bundleProductKeys: 'jira-product-discovery',
	},
	loom: {
		products: [
			{
				productKey: 'loom',
				productName: 'loom',
				productLogoUrl:
					'https://dam-cdn.atl.orangelogic.com/AssetLink/4o2u5s554348i6h5645mq8ar7ntw5450.svg',
			},
		],
		bundleProductKeys: 'loom',
	},
	devai: {
		products: [
			{
				productKey: 'devai.ondemand',
				productName: 'Rovo Dev Agents',
				productLogoUrl:
					'https://dam-cdn.atl.orangelogic.com/AssetLink/417u1uw47033q7c71d0377515lniksis.svg',
				productLogoWhiteUrl:
					'https://dam-cdn.atl.orangelogic.com/AssetLink/027p7mh4up3fs845s7s5ac544n4q4dfy.svg',
			},
		],
		bundleProductKeys: 'devai',
	},
};
export const defaultFeatureFlags = {
	enableTintinMvp: true,
	provisionSecondPartyApps: false,
	enableBundlesAfterSignup: false,
	enableUseCodeAWSContent: false,
	enableDeferredSiteName: false,
	enableDeferredFullName: false,
	enableDefaultExpandedEmail: true,
	enableCutSignUpStepsInHalf: false,
	enableReverseTrial: 'not_enrolled',
};
export const defaultLabels = {
	'WacSignupForm.migrationFeatureList':
		'<h4>Free cloud migration trial for our self-managed customers</h4>\n\n<ul>\n\t<li>Try {productName} cloud at no cost</li>\n\t<li>Up to {usageLimit} {userType}</li>\n\t<li>No impact to your existing self-managed products</li>\n</ul>\n\n<p><a href="/migration/assess/cloud-migration-trial">Learn more</a></p>',
	'WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingFree': 'Get started',
	'WacSignupForm.sideInfoHeaderBundleJSWBitbucket': 'Automate your way to faster releases',
	'WacSignupForm.signupOfferingIncludesFeaturesSocialProofImage':
		'jcr:f91dc7b8-ec95-4ae5-91e3-d5f6acc169dd',
	'WacSignupForm.customizeYourFreePlan': 'Customize your free plan',
	'WacSignupForm.errorDomainLengthMinMsgDevops':
		'Your suite name must be 3 or more lowercase letters and/or numbers. Hyphens are ok if they’re in the middle.',
	'WacSignupForm.signupFormPostContent': 'NO CREDIT CARD REQUIRED',
	'WacSignupForm.loginChooseSignup':
		"<p>Trying to access Confluence? <a href='https://id.atlassian.com/login'>Log in</a></p>",
	'WacSignupForm.cloudEulaText':
		'<p>By clicking below, you agree to the Atlassian <a href="https://www.atlassian.com/legal/cloud-terms-of-service" rel="noopener noreferrer" target="_blank">Cloud Terms of Service</a> and <a href="https://www.atlassian.com/legal/privacy-policy" rel="noopener noreferrer" target="_blank">Privacy Policy</a>.</p>',
	'WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingFreeBeacon':
		'Unlimited free user invites',
	'WacSignupForm.sideInfoHeaderBundleDeveloperMode': 'Cloud Developer Bundle',
	'WacSignupForm.signupOfferingIncludesFeaturesFreeCanvas':
		'Express thoughts and ideas in more ways than ever before\nVisualize how ideas and work fits together throughout workflows\nSpend less time moving ideas to action with integrations\nEnjoy all features and give feedback with free early access',
	'WacSignupForm.existingSite': 'Use an existing site',
	'WacSignupForm.signupOfferingIncludesFeaturesFreeJSD':
		'Connect dev, IT Ops, and business teams on one platform\nDeliver great service experiences across teams, fast\nRespond to changes and keep services up and running\nCollaborate on one platform\nResolve incidents quickly',
	'WacSignupForm.socialSignUpButtonContinueWithMicrosoft': 'Continue with Microsoft',
	'WacSignupForm.submitInitialLabel': 'Start free trial now',
	'WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingFreeAlpha': 'Get started',
	'WacSignupForm.passwordWeak': 'Password Strength: Weak',
	'WacSignupForm.informMessageStartNewSiteSimplified': 'Start a new site',
	'WacSignupForm.socialSignUpOr': 'OR',
	'WacSignupForm.signupOfferingIncludesFeaturesStandardBundleJSWBitbucket':
		'Automatic development updates in Jira\nInteract with Jira issues in Bitbucket and your IDE\nFree for up to 5 Bitbucket and 10 Jira users',
	'WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingFreeBeta': 'Get started',
	'WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingFreeAlpha': 'Free during alpha',
	'WacSignupForm.submitInitialN2ELabel': 'Start now',
	'WacSignupForm.infoBoxModal':
		'<p>A site is the unique URL where you access your Atlassian products&ndash;Confluence, Jira Software, Jira Service Management, or Jira Work Management.<br /><br />You access Bitbucket Cloud account on <a href="https://bitbucket.org/">bitbucket.org</a>.</p>',
	'WacSignupForm.infoBoxSiteJsw':
		'Select an existing site below and we’ll create a new Bitbucket Cloud account for you using the same name.',
	'WacSignupForm.errorFirstNameMsg': 'Please enter your first name.',
	'WacSignupForm.localeErrorButton': 'Learn more',
	'WacSignupForm.errorDomainTakenMsg': 'This site is already taken.',
	'WacSignupForm.errorName': 'Full name can’t use special characters.',
	'WacSignupForm.dropdownWithoutJiraSoftware': 'Sites without Jira Software:',
	'WacSignupForm.signupOfferingTrialLengthTextExistingSite': '1-month free cloud trial',
	'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextTeamCentral':
		'Simplify your status reporting',
	'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextTownsquare':
		'Simplify your status reporting',
	'WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingFreeConfluence':
		'Free for up to 10 users',
	'WacSignupForm.opsgenieDataStorageInfoBoxCopy':
		'<p>Some of your data is automatically stored in the US. <a href="/software/opsgenie/tos">Learn more</a></p>',
	'WacSignupForm.premiumUpgradeHelpTooltipTrigger': 'Site not listed?',
	'WacSignupForm.informMessageCouponError':
		'<p>The coupon you requested is {{couponStatus}}, please <a href="/company/contact">contact us</a> for additional support.</p>',
	'WacSignupForm.freeBreachInfoBoxCopy':
		'<p><strong>Sorry, Cloud Free is limited to 10 users or 3 agents</strong><br />\nIt looks like this site has more than the allowed limit of users (or agents) for our Cloud Free plans. Please choose our Cloud Standard or Premium plans to accommodate the number of users (or agents) on this site.</p>',
	'WacSignupForm.signupOfferingIncludesFeaturesStandardBundleDeveloperMode':
		'<p>You are signing up for free development sites&nbsp;of Atlassian cloud products. This gives you&nbsp;access to the standard versions of Jira Software, Service Collection, and Confluence, which are free forever.</p>\n\n<p>Free development sites are intended to be used for development and testing purposes only and have&nbsp;the usage limits noted below. Atlassian does not offer support for free development sites and reserves the right to delete such sites at any time without notice. Atlassian monitors the usage of such development sites and may cancel any site being used in an unauthorized or unintended manner.</p>\n\n<ul>\n\t<li>Confluence: 5 users free</li>\n\t<li>Jira Software: 5 users free</li>\n\t<li>Service Collection: 1 agent free</li>\n\t<li>All products: Up to 250 GB of file storage</li>\n\t<li>All products: Advanced permissions</li>\n</ul>',
	'WacSignupForm.infoBoxBb':
		"You already have a Bitbucket Cloud account. Create a new site for Jira Software and they'll be automatically integrated.",
	'WacSignupForm.eulaCompassTooltip':
		'<p>The EAP products are considered &ldquo;Beta Versions&rdquo;, as set forth in Section 14 of the TOS and are subject to applicable terms, conditions, and disclaimers. Atlassian will use the information you provide on this sign-up form to contact you about the EAP program, including updates to the program, feedback requests, and offers.</p>',
	'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextCompass':
		'Create a better developer experience with Compass',
	'WacSignupForm.signupOfferingIncludesFeaturesStandard':
		'Full access to all features\nZero obligation, no credit card needed\nAdd up to 10,000 users\nAccess to sales and technical support',
	'WacSignupForm.errorPasswordMinMsg': 'Password must be at least 8 characters long.',
	'WacSignupForm.socialSignUpLoadingText': 'checking a few things...',
	'WacSignupForm.localeError': 'We stand with Ukraine',
	'WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingStandardJSD':
		'7-day free trial for up to 5,000 agents',
	'WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingIncentiveJSD':
		'10 free agents for 12 months',
	'WacSignupForm.signupFormPersonalizedGreeting': 'Welcome back, {username}',
	'WacSignupForm.freeAndNoCreditCardNeeded': 'Free for up to 10 users. No credit card needed.',
	'WacSignupForm.freeToGetStarted': 'Free to get started, no credit card needed.',
	'WacSignupForm.passwordModerate': 'Password Strength: Moderate',
	'WacSignupForm.signupOfferingIncludesFeaturesPremiumBitbucket':
		'<h4>Free cloud migration trials for our self-managed customers</h4>\n\n<ul>\n\t<li>Unlimited users</li>\n\t<li>CI/CD built-in</li>\n\t<li>No impact to self-managed product</li>\n</ul>',
	'WacSignupForm.signupOfferingIncludesFeaturesFreeBundleJSWBitbucket':
		'Automatic development updates in Jira\nInteract with Jira issues in Bitbucket and your IDE\nFree for up to 5 Bitbucket and 10 Jira users',
	'WacSignupForm.signupOfferingIncludesFeaturesFreeBeacon':
		'Increase your visibility and understanding of risks\nBridge the gap between technology and security experts\nExpedite detection, alerting, and response workflows',
	'WacSignupForm.signupOfferingIncludesFeaturesLoom':
		'Record your screen and camera. Create video messages for your coworkers or customers.\nPolish your videos without lifting a finger. Use Loom AI to generate video titles, summaries, and transcripts.\nEngage viewers easily. Add comments, react with emojis, and include CTA buttons to share relevant resources.\nUse Loom for feedback, onboarding, announcements, and presentation videos.',
	'WacSignupForm.socialSignUpButtonSignUpWithGoogle': 'Sign up with Google',
	'WacSignupForm.freeBreachInfoBoxCopyJsmIncentive':
		'<p>Sorry, the number of agents on this site exceeds the total number allowed for the limited-time offer to get 10 free agents. Click <a href="https://atlassian.com/try/cloud/signup?bundle=jira-service-management&amp;edition=standard">here</a> to signup for a paid Standard plan instead.</p>',
	'WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingFreeJSD':
		'Free for up to 3 agents',
	'WacSignupForm.devopsButtonText': 'Sign up',
	'WacSignupForm.signupOfferingIncludesFeaturesPremiumConfluence':
		'Access all features\nKickstart team collaboration\nCapture all the knowledge\nBuild admirable content',
	'WacSignupForm.noCreditCardNeeded': 'No credit card needed.',
	'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextJSD':
		'Powering high-velocity service teams',
	'WacSignupForm.errorEmailInUseMsg':
		"Oops, an Atlassian account with this email already exists. If you are the owner of this account, please <a href='{signInAccountUrl}'>login to continue</a>.",
	'WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingFreeBundlesLayout':
		'For up to 10 users',
	'WacSignupForm.signupOfferingIncludesFeaturesFreeJSDFI':
		'Connect dev, IT Ops, and business teams on one platform\nDeliver great service experiences across teams, fast\nRespond to changes and keep services up and running\nCollaborate on one platform\nResolve incidents quickly',
	'WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingStandardConfluence': 'Start now',
	'WacSignupForm.signupOfferingIncludesFeaturesStandardJSD':
		'Connect dev, IT Ops, and business teams on one platform\nDeliver great service experiences across teams, fast\nRespond to changes and keep services up and running\nCollaborate on one platform\nResolve incidents quickly',
	'WacSignupForm.signupOfferingIncludesFeaturesPremiumBundleJSWBitbucket':
		'Automatic development updates in Jira\nInteract with Jira issues in Bitbucket and your IDE\nFree for up to 5 Bitbucket and 10 Jira users',
	'WacSignupForm.reCaptchaLegal':
		'This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.',
	'WacSignupForm.premiumUpgradeHelpTooltipText':
		'<p>To upgrade to Premium you must log in to your site as a site adminstrator and switch your plan from within billing administration. More information <a href="https://confluence.atlassian.com/display/AdminJIRACloud/Jira+Cloud+plans" target="_blank">here</a>.</p>',
	'WacSignupForm.informMessageSwitchSiteSimplified': 'Switch to a different site',
	'WacSignupForm.showPasswordLabel': 'Show password',
	'WacSignupForm.claimedMigrationSource':
		'<h4>Your extended trial has already been activated</h4>\n\n<p>It looks like someone has already activated this trial.</p>\n\n<p>Log in to <a href="https://my.atlassian.com">my.atlassian.com</a> or contact your site administrator for more information.</p>',
	'WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingStandardConfluence':
		'7-day free trial for up to 50,000 users',
	'WacSignupForm.errorDomainIsAnnualMsg':
		'The Free plan is not yet available for annual subscriptions. Please select a site on a monthly subscription.',
	'WacSignupForm.signupOfferingIncludesFeaturesSocialProofText':
		'Trusted by over 65,000 teams worldwide',
	'WacSignupForm.siteNameLabel': 'Site name',
	'WacSignupForm.siteNameSuiteLabel': 'Name your suite',
	'WacSignupForm.warningTimeoutPending':
		'Something went wrong. Wait a few minutes, then try again.',
	'WacSignupForm.freeBreachInfoBoxConsiderTrial': 'Consider a Standard trial',
	'WacSignupForm.signupOfferingIncludesFeaturesFreeOpsgenie':
		'Alerting and on-call management\nAdd unlimited users\nStart with Essentials features\nUpgrade to another plan at any time',
	'WacSignupForm.errorNameLength': 'Full name must not be greater than 255 characters.',
	'WacSignupForm.signupOfferingIncludesFeaturesFreeJira':
		'Acheive goals faster with project templates\nShare data, workflows, and automate tasks to stay connected\nCentralize reporting and roadmaps across teams\nCustomize Jira with integrations from the Atlassian Marketplace',
	'WacSignupForm.signupOfferingIncludesFeaturesSocialProofHeroImageJiraCore':
		'jcr:f00e5006-4d17-4565-bf8b-89a0867d4388',
	'WacSignupForm.infoBoxSite':
		"You already have a site with other Atlassian products in which Jira Software will be added to. We'll create a new Bitbucket Cloud account for you using the same name.",
	'WacSignupForm.bitbucketAccountDuplicate':
		'Create a new Bitbucket Cloud account using the same name as the site above.',
	'WacSignupForm.emailPlaceholder': 'sallysmith@email.com',
	'WacSignupForm.signupOfferingIncludesFeaturesStandardJSDFI':
		'Access all features\nResolve issues as a team\nQuickly answer common questions\nAutomate incident management',
	'WacSignupForm.signupOfferingIncludesFeaturesSocialProofImageJiraCore':
		'jcr:be8dde61-ffff-4cb6-85a7-a0ec682c77de',
	'WacSignupForm.signupOfferingIncludesFeaturesSocialProofHeroImageBitbucket':
		'jcr:28ba5f01-4096-429e-887f-3d9fc016b65a',
	'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextBitbucket':
		'Source code management & CI/CD',
	'WacSignupForm.signupOfferingIncludesFeaturesSocialProofImageBitbucket':
		'jcr:32afaf4e-4665-4087-9a16-29b429a94336',
	'WacSignupForm.errorDomainLengthMinMsgDeferredSiteName':
		'Must be at least three characters (numerals or lowercase letters only). Can’t start or end with a hyphen (-).',
	'WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingFreeBundlesLayout':
		'Get started for free',
	'WacSignupForm.signupOfferingIncludesFeaturesFreeJiraProductDiscovery':
		'Capture ideas and data from anywhere\nPrioritize the work that will make an impact\nKeep stakeholders informed and engaged\nFully integrated with Jira Software for delivery',
	'WacSignupForm.dropdownWithoutRecommended': 'OTHER SITES',
	'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextBeacon':
		'Threat detection for secure collaboration!',
	'WacSignupForm.freeBreachLimitExceededErrorJsmIncentive':
		'This site exceeds the number of agents eligible for the offer.',
	'WacSignupForm.signupOfferingTrialLengthTextNewSite': '7-day free cloud trial',
	'WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingFreeBeacon': 'Start Now',
	'WacSignupForm.siteNameOptional': 'Site name (optional)',
	'WacSignupForm.errorDomainLengthMaxMsg':
		"That's a bit too long — try something 50 characters or less.",
	'WacSignupForm.passwordLabel': 'Password',
	'WacSignupForm.jsmConfluenceNotice':
		'For the seamless setup of your knowledge base, we suggest adding Jira Service Management to a site that already has Confluence. You won’t be able to link these sites later.',
	'WacSignupForm.errorValidationMessage':
		'Please review the highlighted fields below and try again.',
	'WacSignupForm.dropdownWithRecommended': 'RECOMMENDED SITES',
	'WacSignupForm.signupOfferingIncludesFeaturesFreeStatuspage':
		'Free to set up. Launch it when you&rsquo;re ready.\nAccess to all features and capabilities\nZero obligation, no credit card required\nAdd up to 25 team members\nTechnical and sales support available',
	'WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingFreeJiraProductDiscovery':
		'Free for up to 3 creators and unlimited contributors',
	'WacSignupForm.signupOfferingIncludesFeaturesSocialProofHeroImage':
		'jcr:0c7fa8be-146c-4c6f-84de-de9fb3b84674',
	'WacSignupForm.signupOfferingIncludesFeaturesSocialProofHeroImageConfluence':
		'jcr:12b69d08-6ae8-4b14-ac1c-f3092ccaff97',
	'WacSignupForm.helpTooltipText':
		'Must be at least 3 lowercase characters, numbers and letters only.',
	'WacSignupForm.localeErrorMessage':
		'Following the Russian invasion of Ukraine, we are pausing the sale of new software in Russia and Belarus.',
	'WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeading': 'Start now',
	'WacSignupForm.signupOfferingIncludesFeaturesFreeJSWFI':
		'Scale agile practices\nConsolidate workflows\nExpand visibility\nPlan, track, and release',
	'WacSignupForm.signupOfferingIncludesFeaturesSocialProofImageJSD':
		'jcr:afd73b6a-2ece-4fa3-bfbd-ada0ba2bc2c1',
	'WacSignupForm.informMessageCouponSuccess':
		'<p>The coupon you requested is {{couponStatus}}, please <a href="/company/contact">contact us</a> for additional support.</p>',
	'WacSignupForm.siteNameSuiteDescriptionDevops':
		'* We’ll use this to name your sites and workspaces',
	'WacSignupForm.eulaJsmIncentive':
		'<p>By clicking below, you agree to the Atlassian <a href="https://www.atlassian.com/legal/cloud-terms-of-service">Cloud Terms of Service</a> and <a href="https://www.atlassian.com/legal/privacy-policy">Privacy Policy</a> and <a href="https://atlassian.com/end-bsm-now/terms-and-conditions">Terms &amp; Conditions</a> of the offer.</p>',
	'WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingIncentiveJSD': 'Start now',
	'WacSignupForm.alwaysFreeForUpto': 'Always free for up to 10 users.',
	'WacSignupForm.signupFormGreeting': 'Create your account',
	'WacSignupForm.signupOfferingIncludesHeading': 'Trial includes',
	'WacSignupForm.emailLabel': 'Work email',
	'WacSignupForm.signupOfferingIncludesFeaturesPremiumJSDFI':
		'Connect dev, IT Ops, and business teams on one platform\nDeliver great service experiences across teams, fast\nRespond to changes and keep services up and running\nCollaborate on one platform\nResolve incidents quickly',
	'WacSignupForm.firstNameLabel': 'First name',
	'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextJiraCore':
		'Connected teams work better together',
	'WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingFreeConfluence': 'Get started',
	'WacSignupForm.signupOfferingIncludesFeaturesPremiumStatuspage':
		'Free to set up. Launch it when you&rsquo;re ready.\nAccess to all features and capabilities\nZero obligation, no credit card required\nAdd up to 25 team members\nTechnical and sales support available',
	'WacSignupForm.siteNameInstructionsExperimentB':
		'This site name is just a suggestion. Feel free to change to something your team will recognize.',
	'WacSignupForm.yourBitbucketAccount': 'Your Bitbucket Cloud account',
	'WacSignupForm.inputSiteNameMessage':
		'Your site name appears in the URL for your Atlassian products. Most people use their team or company name. You can change your site name later.',
	'WacSignupForm.marketingCommunicationsCheckboxSignupText':
		'Yes! I would like to receive promotional emails including product news, events and more from Atlassian and its affiliates.',
	'WacSignupForm.signupOfferingIncludesFeaturesStandardJiraCore':
		'Access all features\nCustomize project templates\nTrack and automate every detail\nAnalyze team progress',
	'WacSignupForm.passwordVeryStrong': 'Password Strength: Very strong',
	'WacSignupForm.signupOfferingIncludesFeaturesFreeBundleJSD':
		'Connect dev, IT Ops, and business teams on one platform\nDeliver great service experiences across teams, fast\nRespond to changes and keep services up and running\nCollaborate on one platform\nResolve incidents quickly',
	'WacSignupForm.socialSignUpErrorTextContactUs':
		'<div>If the problem persists, <a href="{contactUsUrl}">contact us</a>.</div>',
	'WacSignupForm.signupOfferingIncludesFeaturesFreeTeamCentral':
		'Connect work to outcomes\nGet updates with just enough context\nLet Atlas know everyone, so you can too\nLearn without knowing who to ask',
	'WacSignupForm.devopsCarouselButton': 'Get started in {product}',
	'WacSignupForm.invalidMigrationSource':
		'<h4>Invalid trial activation</h4>\n\n<p>It looks like we weren&#39;t able to activate your cloud migration trial.</p>\n\n<p>Check with the site administrator, or login to <a href="https://my.atlassian.com">my.atlassian.com</a> to confirm your activation link is complete and correct, and that you have an eligible server or Data Center license.</p>',
	'WacSignupForm.infoBoxModalCta': 'Understand site and Bitbucket Cloud account',
	'WacSignupForm.dropdownWithJiraSoftware': 'Sites with Jira Software:',
	'WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingStandard': 'Start now',
	'WacSignupForm.opsgenieDataRegionLabel':
		'Select the data center region to store your Opsgenie specific product data',
	'WacSignupForm.informDomainEmptyMsg': 'Looking to add products to an existing site?',
	'WacSignupForm.signupOfferingIncludesFeaturesFreeCompass':
		'Reduce context switching with a comprehensive software catalog\nKeep your architecture reliable, performant, and secure with scorecards and metrics\nConnect your existing tools and data and create custom integrations for a bespoke developer experience',
	'WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingStandardAtlas':
		'14-day free trial for up to 35,000 users',
	'WacSignupForm.errorTimeout':
		'<p>It&#39;s taking longer than expected to get you started. Please check your inbox to see if the order has completed successfully, or <a href="/company/contact">contact us</a>.</p>',
	'WacSignupForm.signupOfferingIncludesFeaturesPremiumJiraCore':
		'Let teams collaborate at scale\nCustomize how work is tracked\nExpand visibility\nSave time with automation',
	'WacSignupForm.infoBoxDefault': '',
	'WacSignupForm.infoBoxSiteBb':
		'You already have a site with other Atlassian products in which Jira Software will be added to. You also have a Bitbucket Cloud account. They will be automatically integrated.',
	'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextJiraProductDiscovery':
		'Transform product ideas into business impact',
	'WacSignupForm.deferredSiteNameTooltipText':
		'Your site name is the URL used to find your site, so try something your team will easily recognize.',
	'WacSignupForm.siteNameSuiteDescriptionLabel':
		'* We’ll use this to name your site and workspaces',
	'WacSignupForm.socialSignUpOrSignUpWith': 'Or sign up with',
	'WacSignupForm.submitN2ELabel': 'Agree and start now',
	'WacSignupForm.socialSignUpButtonContinueWithGoogle': 'Continue with Google',
	'WacSignupForm.eulaCutSignupInHalf':
		"<p>By clicking \"Sign up\" below, you agree to the Atlassian <a href='https://www.atlassian.com/legal/cloud-terms-of-service'>Cloud Terms of Service</a> and <a href='https://www.atlassian.com/legal/privacy-policy'>Privacy Policy</a>.</p>",
	'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextJSDIncentive':
		'Get started with 10 agents for free for 12 months!*',
	'WacSignupForm.signupOfferingIncludesFeaturesFreeBitbucket':
		'Included build minutes and Git LFS\nNative Jira integration\nEasily extensible\nSecure & reliable',
	'WacSignupForm.signupOfferingIncludesHeadingFree': 'Subscription includes',
	'WacSignupForm.signupOfferingIncludesFeaturesStandardJSWFI':
		'\nAccess all features\nScale agile practices\nConsolidate workflows\nPlan, track, and release',
	'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextConfluence':
		'Trusted by over 75,000 teams worldwide',
	'WacSignupForm.eulaCompass':
		'<p>By signing up for this Early Access Program (&ldquo;EAP&rdquo;), you agree to the Atlassian <a href="https://www.atlassian.com/legal/cloud-terms-of-service" rel="noopener noreferrer" target="_blank">Cloud Terms of Service</a> (&ldquo;TOS&rdquo;) and acknowledge the Atlassian <a href="https://www.atlassian.com/legal/privacy-policy" rel="noopener noreferrer" target="_blank">Privacy Policy</a></p>',
	'WacSignupForm.informDomainIsUsersMsg': 'Is it yours?',
	'WacSignupForm.errorDomainTakenMsgDeferredSiteName': 'This site name is already taken.',
	'WacSignupForm.passwordPlaceholder': 'Combine letters, numbers and symbols',
	'WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingFreeAtlas': 'Start Now',
	'WacSignupForm.fullNameLabel': 'Full name',
	'WacSignupForm.passwordStrong': 'Password Strength: Strong',
	'WacSignupForm.userTypeUsersLabel': 'users',
	'WacSignupForm.socialSignUpSomethingWentWrong': '<h3>Something went wrong</h3>',
	'WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingFreeJSD': 'Start now',
	'WacSignupForm.siteNameN2ELabel': 'Your site',
	'WacSignupForm.errorLastNameMsg': 'Please enter your last name.',
	'WacSignupForm.personalizedNameSiteMessage': 'Let’s name your site, {username}',
	'WacSignupForm.siteNamePlaceholder': 'yoursite',
	'WacSignupForm.eulaChooseSignup':
		"<p>By clicking “Continue” below, you agree to the Atlassian Cloud <a href='https://www.atlassian.com/legal/cloud-terms-of-service'>Terms of Service</a> and acknowledge the Atlassian <a href='https://www.atlassian.com/legal/privacy-policy'>Privacy Policy</a>.</p>",
	'WacSignupForm.socialSignUpButtonSignUpWithEmail': 'Sign up with email',
	'WacSignupForm.helpTooltipTextDevops':
		'Choose a name for the sites and workspaces that will make up your suite. Most teams use their company or organization.',
	'WacSignupForm.informEmailLoggedInMsg.link':
		'<a href="{switchAccountUrl}">Sign in with a different Atlassian account</a>',
	'WacSignupForm.signupOfferingIncludesFeaturesSocialProofImageConfluence':
		'jcr:53e25eff-e025-41d0-88ec-2f1420f89131',
	'WacSignupForm.errorCaptchaMsg': 'Error with captcha verification.',
	'WacSignupForm.signupOfferingIncludesFeaturesSocialProofHeroImageJSD':
		'jcr:45864a30-5470-4cbe-be59-9aae63492229',
	'WacSignupForm.freeBreachLimitExceededError': 'This site has more users than Free allows.',
	'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextCanvas':
		'A collaborative whiteboard for teams',
	'WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingFreeBeta': 'Free during beta',
	'WacSignupForm.errorDomainLengthMinMsg':
		'Your site name must be 3 or more lowercase letters and/or numbers. Hyphens are ok if they’re in the middle.',
	'WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingFreeFabric':
		'Unlimited free users',
	'WacSignupForm.lastNameLabel': 'Last name',
	'WacSignupForm.jswTrialNotice': "You'll get a 1-month free trial of Jira Software for this site.",
	'WacSignupForm.errorEmailInvalidMsg': 'Please enter a valid email address.',
	'WacSignupForm.lastNamePlaceholder': 'Last',
	'WacSignupForm.accountIdMisMatch':
		'<span>Something went wrong. Please refresh your page, then try again.</span>',
	'WacSignupForm.startButtonTextChooseSignup': 'Continue',
	'WacSignupForm.selectOrganization': 'Select your Atlassian organization',
	'WacSignupForm.signupOfferingIncludesFeaturesPremiumJSWFI':
		'Access all features\nScale agile practices\nConsolidate workflows\nPlan, track, and release',
	'WacSignupForm.signupOfferingIncludesFeaturesPremium':
		'Full access to all features\nZero obligation, no credit card needed\nAdd up to 10,000 users\nAccess to sales and technical support',
	'WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingFreeJiraProductDiscovery':
		'Get started',
	'WacSignupForm.signupOfferingTrialLengthTextNewSiteOpsgenie': '14-day free Essentials trial',
	'WacSignupForm.signupOfferingIncludesFeaturesStandardConfluence':
		'Access all features\nKickstart team collaboration\nCapture all the knowledge\nBuild admirable content',
	'WacSignupForm.socialSignUpSorryForTheInconvenience': '<div>Sorry for the inconvenience</div>',
	'WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingFreeAtlas':
		'Free up to 35,000 users',
	'WacSignupForm.freeBreachInfoBoxStartTrialCta': 'Start a 30-day trial',
	'WacSignupForm.siteNameOptionalMessageN2E': 'Choose an existing site below, or create a new one.',
	'WacSignupForm.siteNameInstructions':
		'Must be at least three characters (numbers or lowercase letters only) and can’t start or end with a hyphen (-).',
	'WacSignupForm.siteNameOptionalMessageN2N': "Don't worry, you can change this later.",
	'WacSignupForm.firstNamePlaceholder': 'First',
	'WacSignupForm.signupOfferingIncludesFeaturesFreeJiraCore':
		'Calendar, list, timeline, and board views to track work\nQuickly create forms with a drag-and-drop builder\nSave your team&#39;s time with our automation library\nHelp teams stay in sync with customizable workflows',
	'WacSignupForm.submitCouponLabel': 'Agree',
	'WacSignupForm.warningNetworkError': 'Something went wrong. Please try again.',
	'WacSignupForm.userTypeAgentsLabel': 'agents',
	'WacSignupForm.signupOfferingIncludesFeaturesPremiumJSD':
		'Connect dev, IT Ops, and business teams on one platform\nDeliver great service experiences across teams, fast\nRespond to changes and keep services up and running\nCollaborate on one platform\nResolve incidents quickly',
	'WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingStandardBeacon':
		'Unlimited free users',
	'WacSignupForm.signupOfferingIncludesFeaturesFreeConfluence':
		'Kickstart team collaboration\nIncrease transparency\nCapture all the knowledge\nBuild admirable content',
	'WacSignupForm.errorEmailInUseLoginToContinueMsg': 'Log in to continue.',
	'WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingStandard':
		'7-day free trial for up to 35,000 users',
	'WacSignupForm.signupOfferingIncludesFeaturesFree':
		'Access to Free features\n2 GB storage\nFor up to 10 users\nCommunity Support',
	'WacSignupForm.useDifferentAccountSignin.link':
		'<a href="{switchAccountUrl}">Use a different Atlassian account</a>',
	'WacSignupForm.informMessageDeveloperWarning':
		'<h4>You are signing up for a free development instance of Atlassian Cloud.</h4>\n\n<p>Free development instances are intended to be used for development and testing purposes only and has the usage limits noted below.Atlassian does not offer support for free development instances and reserves the right to delete such instances at any time without notice.Atlassian monitors the usage of such development instances and may cancel any instance being used in an unauthorized or unintended manner.</p>\n\nJira Software, Jira Core: 5 users free\nJira Service Desk: 1 agent free\nConfluence: 5 users free',
	'WacSignupForm.submitProcessingLabel': 'Starting...',
	'WacSignupForm.signupOfferingIncludesFeaturesIncentiveJSD':
		'Access all features of our Standard plan\nConnect dev, IT Ops, and business teams on one platform\nDeliver great service experiences across teams, fast\nRespond to changes and keep services up and running\nCollaborate on one platform\nResolve incidents quickly\n\n<p>* After one year, convert to a paid plan or keep using Jira Service Management on the Free plan with up to 3 agents.</p>',
	'WacSignupForm.informDomainAddToExistingsMsg': 'Add products to existing site',
	'WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingFree':
		'Free for up to 10 users — no credit card needed.',
	'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextJira':
		'Trusted by over 65,000 teams worldwide',
	'WacSignupForm.FirstImpressions.firstImpressionsSocialProofImageTeamCentral':
		'jcr:80e875ca-274f-44fd-b1d3-50e47c43a73b',
	'WacSignupForm.FirstImpressions.socialSignUpButtonSignUpWithEmail': 'Sign up with email',
	'WacSignupForm.FirstImpressions.inputLabelFullName': 'Full name',
	'WacSignupForm.FirstImpressions.teamCentralGetConfluenceFreeButtonProductName': 'Confluence',
	'WacSignupForm.FirstImpressions.firstImpressionsHeroImage':
		'jcr:0c7fa8be-146c-4c6f-84de-de9fb3b84674',
	'WacSignupForm.FirstImpressions.errorSsoInUse':
		"You must use single sign-on to access your account and continue signing up for your product. <a href='{redirectUrl}'>Login to continue</a>.",
	'WacSignupForm.FirstImpressions.inputLabelRequired': 'Required',
	'WacSignupForm.FirstImpressions.firstImpressionsLoggedOutFormHeader': 'Let get it started!',
	'WacSignupForm.FirstImpressions.firstImpressionsHeroImageJSD':
		'jcr:45864a30-5470-4cbe-be59-9aae63492229',
	'WacSignupForm.FirstImpressions.firstImpressionsLoggedInFormHeader': 'Welcome back, {userName}',
	'WacSignupForm.FirstImpressions.firstImpressionsSocialProofImageConfluence':
		'jcr:ed997381-ade2-440b-8374-7d2095bd7b38',
	'WacSignupForm.FirstImpressions.teamCentralGetJiraFreeButtonProductName': 'Jira Software',
	'WacSignupForm.FirstImpressions.teamCentralLoggedOutViewFormHeader': 'Hi there',
	'WacSignupForm.FirstImpressions.firstImpressionsHeroImageJira':
		'jcr:775fdafc-0622-4a54-acdf-1c3ca0da5e83',
	'WacSignupForm.FirstImpressions.firstImpressionsHeroImageFabric':
		'jcr:978c45e6-3cf7-40d1-9a42-172cc8e77e60',
	'WacSignupForm.FirstImpressions.firstImpressionsHeroImageBeacon':
		'jcr:f82f862b-5d6b-49ec-9d95-886664208834',
	'WacSignupForm.FirstImpressions.teamCentralGetConfluenceFreeButtonTitle': 'Get it free',
	'WacSignupForm.FirstImpressions.firstImpressionsSocialProofImageJSD':
		'jcr:4bacc2d6-c0ff-4949-955e-50cde04a3898',
	'WacSignupForm.FirstImpressions.inputLabelWorkEmail': 'Work email',
	'WacSignupForm.FirstImpressions.submitButtonLabel': 'Agree',
	'WacSignupForm.FirstImpressions.firstImpressionsHeroImageTeamCentral':
		'jcr:9991958d-3d80-45fd-9af0-c53d15270ec8',
	'WacSignupForm.FirstImpressions.firstImpressionsHeroImageJiraProductDiscovery':
		'jcr:7cfe6bed-77da-410b-8fcc-2c3f3f78cef5',
	'WacSignupForm.FirstImpressions.teamCentralIneligibleViewSwitchAccountLink':
		'Sign in with a different Atlassian account',
	'WacSignupForm.FirstImpressions.noCreditCardRequiredFooter': 'No credit card required',
	'BxpSignup.PaymentDetailsHeading': 'Add your payment details',
	'BxpSignup.PaymentDetailsSubtitle': 'to start a Rovo Dev 30 day free trial',
	'BxpSignup.PaymentDetailsBack': 'Back',
	'BxpSignup.PaymentDetailsSubmit': "I've added my payment details",
	'BxpSignup.AddPaymentMethod.Title': 'Add a payment method to start your trial',
	'BxpSignup.AddPaymentMethod.Intro':
		"We couldn't find a payment method for your site, a billing admin must add one before you start a trial.",
	'BxpSignup.AddPaymentMethod.NoChargeTitle': 'No charge until trial ends',
	'BxpSignup.AddPaymentMethod.NoChargeBody':
		"There's no charge today, billing doesn't begin until the end of your trial.",
	'BxpSignup.AddPaymentMethod.CancelAnytimeTitle': 'Cancel anytime',
	'BxpSignup.AddPaymentMethod.CancelAnytimeBody':
		'If you want to end your trial, cancel anytime in Atlassian Administration.',
	'BxpSignup.AddPaymentMethod.HowToTitle': 'How to add a payment method',
	'BxpSignup.AddPaymentMethod.Step1Title': 'Go to payment methods in Atlassian Administration',
	'BxpSignup.AddPaymentMethod.Step1Body': 'Billing admin role required to add payment methods.',
	'BxpSignup.AddPaymentMethod.ReadAboutPermissions': 'Read about permissions',
	'BxpSignup.AddPaymentMethod.OpenPaymentMethods': 'Open payment methods',
	'BxpSignup.AddPaymentMethod.Step2Title': 'Enter your billing details',
	'BxpSignup.AddPaymentMethod.Step2Body':
		'Add a billing address and payment method. We accept credit cards and PayPal.',
	'BxpSignup.AddPaymentMethod.Step3Title': 'Close the payment methods tab',
	'BxpSignup.AddPaymentMethod.Step3Body':
		"When you're done, close the payment methods window and return here.",
	'BxpSignup.AddPaymentMethod.Step4Title': 'Return and set up your trial',
	'BxpSignup.AddPaymentMethod.Step4Body':
		'After adding a payment method, return to where you started and set up your trial again.',
	'BxpSignup.AddPaymentMethod.CloseAndGoBack': 'Close and go back',
	'WacSignupForm.FirstImpressions.socialSignUpButtonContinueWithGoogle': 'Continue with Google',
	'WacSignupForm.FirstImpressions.firstImpressionsHeroImageJiraCore':
		'jcr:f00e5006-4d17-4565-bf8b-89a0867d4388',
	'WacSignupForm.FirstImpressions.teamCentralIneligibleViewFormHeader': 'Welcome back, {userName}',
	'WacSignupForm.FirstImpressions.firstImpressionsLoggedOutFormSubHeader':
		'Free for up to 10 users',
	'WacSignupForm.FirstImpressions.firstImpressionsSocialProofImageJira':
		'jcr:37f44a00-1c5f-45e7-b3f5-a38ad08c46c1',
	'WacSignupForm.FirstImpressions.teamCentralGetJiraFreeButtonProductDescription':
		'Project and issue tracking',
	'WacSignupForm.FirstImpressions.teamCentralLoggedOutViewAlreadyHaveAccount':
		'if you already have an Atlassian account',
	'WacSignupForm.FirstImpressions.firstImpressionsHeroImageCompass':
		'jcr:ddb40094-3568-4eee-84fb-adfd5b20ca96',
	'WacSignupForm.FirstImpressions.teamCentralGetJiraFreeButtonTitle': 'Get it free',
	'WacSignupForm.FirstImpressions.inputLabelFullNameLengthError': 'Must be 255 characters or less',
	'WacSignupForm.FirstImpressions.inputLabelWorkEmailError': 'Invalid email address',
	'WacSignupForm.FirstImpressions.firstImpressionBackgroundImage':
		'jcr:fa398d64-ddab-4e01-b3bf-90042efc7638',
	'WacSignupForm.FirstImpressions.firstImpressionsHeroImageConfluence':
		'jcr:12b69d08-6ae8-4b14-ac1c-f3092ccaff97',
	'WacSignupForm.FirstImpressions.teamCentralLoggedOutViewLogIn': 'Log in',
	'WacSignupForm.FirstImpressions.firstImpressionsSocialProofImageJiraProductDiscovery':
		'jcr:a8911809-1897-4fbc-9a7e-086e07e07199',
	'WacSignupForm.FirstImpressions.teamCentralSignUpForOtherProductsFirst':
		'Sign up for Jira or Confluence to coordinate and collaborate on Team Central',
	'WacSignupForm.FirstImpressions.firstImpressionsEula':
		"<p>By signing up, you agree to the Atlassian <a href='https://www.atlassian.com/legal/cloud-terms-of-service'>Cloud Terms of Service</a> and <a href='https://www.atlassian.com/legal/privacy-policy'>Privacy Policy.</a></p>",
	'WacSignupForm.FirstImpressions.teamCentralGetConfluenceFreeButtonProductDescription':
		'Document collaboration',
	'WacSignupForm.FirstImpressions.firstImpressionsSocialProofImage':
		'jcr:37f44a00-1c5f-45e7-b3f5-a38ad08c46c1',
	'WacSignupForm.FirstImpressions.firstImpressionsRecaptcha':
		'This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.',
	'WacSignupForm.FirstImpressions.firstImpressionsSocialProofImageJiraCore':
		'jcr:f2b4976d-a53a-42a0-93ec-def9b87fe654',
	'WacSignupForm.SimpleSignup.noCreditCardRequiredFooter': 'Always free, no credit card needed.',
	'WacSignupForm.SimpleSignup.slideProductConfirmationProductsNew': 'New Products',
	'WacSignupForm.SimpleSignup.jswMobileNavImage': 'jcr:75a99fa9-2d9f-4eb6-b856-cb450b77f656',
	'WacSignupForm.SimpleSignup.productListBitbucketDescription': 'Ship quality code as a team',
	'WacSignupForm.SimpleSignup.slideProductConfirmationHeader': 'Review your toolchain',
	'WacSignupForm.SimpleSignup.inputLabelSitenameNew': 'Name your suite',
	'WacSignupForm.SimpleSignup.socialSignUpButtonContinueWithGoogle': 'Continue with Google',
	'WacSignupForm.SimpleSignup.slideExistingSiteSubHeader':
		'Start building your toolchain with our flagship products for free, then upgrade or add more third-party tools later.',
	'WacSignupForm.SimpleSignup.socialSignUpButtonSignUpWithEmail': 'Sign up with email',
	'WacSignupForm.SimpleSignup.errorName': 'Invalid name pattern.',
	'WacSignupForm.SimpleSignup.inputLabelFullName': 'Full name',
	'WacSignupForm.SimpleSignup.errorEmailInUse':
		"Oops, an Atlassian account with this email already exists. If you are the owner of this account, please <a href='{signInAccountUrl}'>login to continue</a>.",
	'WacSignupForm.SimpleSignup.passwordWeak': 'Weak',
	'WacSignupForm.SimpleSignup.inputDescriptionSitenameExisting':
		'The address your team will use to access Jira Software',
	'WacSignupForm.SimpleSignup.simpleSignupEula':
		'By clicking "Sign up", you agree to the Atlassian <a href="https://www.atlassian.com/legal/cloud-terms-of-service">Cloud Terms of Service</a> and <a href="https://www.atlassian.com/legal/privacy-policy">Privacy Policy</a>.',
	'WacSignupForm.SimpleSignup.atlassianLogoImage': 'jcr:fbe85a9f-3381-4a48-afbc-074287bc4ba9',
	'WacSignupForm.SimpleSignup.errorSsoInUse':
		"You must use single sign-on to access your account and continue signing up for your product. <a href='{signInAccountUrl}'>Login to continue.</a>",
	'WacSignupForm.SimpleSignup.productListOpsgenieDescription': 'Streamline incident management',
	'WacSignupForm.SimpleSignup.submitButtonLoggedOut': 'Sign up',
	'WacSignupForm.SimpleSignup.openDevOps': 'Open DevOps',
	'WacSignupForm.SimpleSignup.slideConfirmationHeader': "You're almost there!",
	'WacSignupForm.SimpleSignup.errorSitenameUnavailable': 'This suite is already taken.',
	'WacSignupForm.SimpleSignup.inputDescriptionSitenameNew': '',
	'WacSignupForm.SimpleSignup.inputLabelRequired': 'Enter your email',
	'WacSignupForm.SimpleSignup.simpleSignupLoggedOutFormSubmitError':
		'Something went wrong, please try again.',
	'WacSignupForm.SimpleSignup.slideExistingSiteSubHeaderTooltip':
		'If your chosen site does not include Jira software, we’ll add and integrate it with your suite.',
	'WacSignupForm.SimpleSignup.slideConfirmationSubHeaderText':
		'Your new products are now connected to your site.',
	'WacSignupForm.SimpleSignup.noCard': 'No Credit Card Required',
	'WacSignupForm.SimpleSignup.inputToggleSitenameExisting': 'Use an existing site',
	'WacSignupForm.SimpleSignup.socialSignUpButtonSignupWithGoogle': 'Sign up with Google',
	'WacSignupForm.SimpleSignup.socialSignUpOr': 'OR',
	'WacSignupForm.SimpleSignup.welcomeMessageLoggedOut': 'Create your account',
	'WacSignupForm.SimpleSignup.passwordStrength': 'Password strength:',
	'WacSignupForm.SimpleSignup.slideProductConfirmationSubHeader':
		'You’ll connect these products to your site. Remember, new products are free!',
	'WacSignupForm.SimpleSignup.errorSitenameInvalid':
		'Your suite name must be 3 or more lowercase letters and/or numbers. Hyphens are ok if they’re in the middle.',
	'WacSignupForm.SimpleSignup.siteNameFormHeader':
		'Your site name will be in the URL to access your site, so pick a name that your team will recognize.',
	'WacSignupForm.SimpleSignup.slideExistingWorkspaceSubHeader':
		'Integrate Jira, Confluence and Opsgenie with Bitbucket for free, then upgrade or add more third-party tools later.',
	'WacSignupForm.SimpleSignup.slideConfirmationGetStarted': 'Get started in {product}',
	'WacSignupForm.SimpleSignup.inputLabelWorkEmailError': 'Invalid email address',
	'WacSignupForm.SimpleSignup.submitButtonLoggedIn': 'Sign up',
	'WacSignupForm.SimpleSignup.inputLabelFirstName': 'First name',
	'WacSignupForm.SimpleSignup.simpleSignupLoggedOutFormSubHeader':
		'Your Free cloud plan supports up to 10 users and 2 GB of file storage.',
	'WacSignupForm.SimpleSignup.inputLabelEmail': 'Work email',
	'WacSignupForm.SimpleSignup.simpleSignupLoggedOutFormHeader': "Let's get started",
	'WacSignupForm.SimpleSignup.passwordModerate': 'Moderate',
	'WacSignupForm.SimpleSignup.productListConfluenceName': 'Confluence Cloud',
	'WacSignupForm.SimpleSignup.slideExistingSiteHeader': 'Let’s get started',
	'WacSignupForm.SimpleSignup.productListOpsgenieName': 'Opsgenie Cloud',
	'WacSignupForm.SimpleSignup.inputLabelSitenameExisting':
		'Select a site (or type a name to create a new one)',
	'WacSignupForm.SimpleSignup.errorTimeoutN2N':
		"<span>It's taking longer than expected to get you started. Please check your inbox to see if the request has completed successfully, or <a href='https://www.atlassian.com/company/contact'>contact us</a>.</span>",
	'WacSignupForm.SimpleSignup.simpleSignupSamlRequired':
		'You must use single sign-on to access your account and continue signing up for your product. <a href="{loginUrl}">Login to continue</a>',
	'WacSignupForm.SimpleSignup.errorTimeoutN2E':
		"<span>It’s taking longer than expected to get you started. Please refresh and try again or <a href='https://www.atlassian.com/company/contact' track-link-ga='error-contact-us'>contact us</a>.</span>",
	'WacSignupForm.SimpleSignup.inputLabelWorkspaceExisting':
		'Select a workspace (or type a name to create a new one)',
	'WacSignupForm.SimpleSignup.nextButton': 'Next',
	'WacSignupForm.SimpleSignup.slideProductConfirmationProductsExisting': 'Existing Products',
	'WacSignupForm.SimpleSignup.inputLabelWorkEmail': 'Work email',
	'WacSignupForm.SimpleSignup.marketingConsent':
		'Yes! I would like to receive promotional emails including product news, events and more from Atlassian and its affiliates.',
	'WacSignupForm.SimpleSignup.inputLabelLastName': 'Last name',
	'WacSignupForm.SimpleSignup.provisioningTakesTime':
		'Please wait a moment, this can take up to a minute...',
	'WacSignupForm.SimpleSignup.productListJiraSoftwareName': 'Jira Software',
	'WacSignupForm.SimpleSignup.slideConfirmationCardText':
		'You can access your connected work in the <b>Pages</b>, <b>Code</b>, or <b>On-call</b> tabs of your project.',
	'WacSignupForm.SimpleSignup.inputLabelPassword': 'Password',
	'WacSignupForm.SimpleSignup.submitButtonLabel': 'Sign up',
	'WacSignupForm.SimpleSignup.productListConfluenceDescription':
		'Collaborate on important documents',
	'WacSignupForm.SimpleSignup.passwordStrong': 'Strong',
	'WacSignupForm.SimpleSignup.simpleSignupRecaptcha':
		'This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.',
	'WacSignupForm.SimpleSignup.errorEmailInvalid': 'Please enter a valid email address',
	'WacSignupForm.SimpleSignup.productListJiraSoftwareDescription':
		'Mission control for your entire team',
	'WacSignupForm.SimpleSignup.socialSignUpDividerLabel': 'OR',
	'WacSignupForm.SimpleSignup.previousButton': 'Prev',
	'WacSignupForm.SimpleSignup.productListBitbucketName': 'Bitbucket Cloud',
	'WacSignupForm.SimpleSignup.inputSitenameExistingPlaceholder': 'Select or create a new site',
	'WacSignupForm.SimpleSignup.inputToggleSitenameNew': 'Start a new site',
	'WacSignupForm.SimpleSignup.passwordVeryStrong': 'Very strong',
	'WacSignupForm.SimpleSignup.inputPlaceholderWorkEmail': 'Eg: you@company.com',
	'WacSignupForm.SimpleSignup.slideConfirmationFooterText':
		'Next, dive into a project to start exploring Atlassian Open DevOps.',
	'WacSignupForm.SimpleSignup.errorPasswordMinMsg': 'Password must be at least 8 characters long',
	'PasswordStrength.passwordWeak': 'Password Strength: Weak',
	'PasswordStrength.passwordModerate': 'Password Strength: Moderate',
	'PasswordStrength.passwordStrong': 'Password Strength: Strong',
	'PasswordStrength.passwordVeryStrong': 'Password Strength: Very strong',
	'WacSignupForm.signupOfferingIncludesFeaturesStandardUpgradeTitle':
		'Upgrade to the Standard plan',
	'WacSignupForm.signupOfferingIncludesFeaturesStandardBulletIntro':
		'The Standard plan also includes:',
	'WacSignupForm.signupOfferingIncludesFeaturesStandardConfluenceUpgradeBody':
		'Get a free 14-day trial of Confluence Standard for unlimited users, additional storage, and much more. Cancel anytime.',
	'WacSignupForm.signupOfferingIncludesFeaturesStandardConfluenceBullet1Title':
		'Page & user permissions',
	'WacSignupForm.signupOfferingIncludesFeaturesStandardConfluenceBullet1Body':
		'Control space and page access',
	'WacSignupForm.signupOfferingIncludesFeaturesStandardConfluenceBullet2Title': 'Page insights',
	'WacSignupForm.signupOfferingIncludesFeaturesStandardConfluenceBullet2Body':
		'Give content creators insights on page views and comments',
	'WacSignupForm.signupOfferingIncludesFeaturesStandardConfluenceBullet3Title':
		'Business hour support',
	'WacSignupForm.signupOfferingIncludesFeaturesStandardConfluenceBullet3Body':
		'Get support from Atlassian’s team of experts',
	'WacSignupForm.signupOfferingIncludesFeaturesStandardJsmUpgradeBody':
		'Get a free 14-day trial of Jira Service Management Standard for unlimited agents, additional storage, and much more. Cancel anytime.',
	'WacSignupForm.signupOfferingIncludesFeaturesStandardJsmBullet1Title': 'On-call management',
	'WacSignupForm.signupOfferingIncludesFeaturesStandardJsmBullet1Body':
		'Create custom routing rules and escalation policies',
	'WacSignupForm.signupOfferingIncludesFeaturesStandardJsmBullet2Title':
		'Unlimited email notifications',
	'WacSignupForm.signupOfferingIncludesFeaturesStandardJsmBullet2Body':
		'Update everyone about activity on requests',
	'WacSignupForm.signupOfferingIncludesFeaturesStandardJsmBullet3Title': 'Business hour support',
	'WacSignupForm.signupOfferingIncludesFeaturesStandardJsmBullet3Body':
		'Get support from Atlassian’s team of experts',
	'WacSignupForm.signupOfferingIncludesFeaturesStandardJswUpgradeBody':
		'Get a free 14-day trial of Jira Standard for unlimited users, additional storage, and much more. Cancel anytime.',
	'WacSignupForm.signupOfferingIncludesFeaturesStandardJswBullet1Title': 'User roles & permissions',
	'WacSignupForm.signupOfferingIncludesFeaturesStandardJswBullet1Body':
		'Have more control over which users have access to different projects and actions.',
	'WacSignupForm.signupOfferingIncludesFeaturesStandardJswBullet2Title': 'Anonymous access',
	'WacSignupForm.signupOfferingIncludesFeaturesStandardJswBullet2Body':
		'Give secure access to people outside your team.',
	'WacSignupForm.signupOfferingIncludesFeaturesStandardJswBullet3Title': 'Business hour support',
	'WacSignupForm.signupOfferingIncludesFeaturesStandardJswBullet3Body':
		'Get support from Atlassian’s team of experts',
	'WacSignupForm.signupOfferingIncludesFeaturesPremiumUpgradeTitle': 'Upgrade to the Premium plan',
	'WacSignupForm.signupOfferingIncludesFeaturesPremiumBulletIntro':
		'The Premium plan also includes:',
	'WacSignupForm.signupOfferingIncludesFeaturesPremiumConfluenceUpgradeBody':
		'Get a free 30-day trial of Confluence Premium for unlimited users, unlimited storage, and much more. Cancel anytime.',
	'WacSignupForm.signupOfferingIncludesFeaturesPremiumConfluenceBullet1Title':
		'Atlassian Intelligence (AI)',
	'WacSignupForm.signupOfferingIncludesFeaturesPremiumConfluenceBullet1Body':
		'AI to create value faster, turn insights into action, and communicate efficiently',
	'WacSignupForm.signupOfferingIncludesFeaturesPremiumConfluenceBullet2Title':
		'Unlimited whiteboards',
	'WacSignupForm.signupOfferingIncludesFeaturesPremiumConfluenceBullet2Body':
		'A digital whiteboard to brainstorm, plan, and action work like never before',
	'WacSignupForm.signupOfferingIncludesFeaturesPremiumConfluenceBullet3Title': 'Premium support',
	'WacSignupForm.signupOfferingIncludesFeaturesPremiumConfluenceBullet3Body':
		'Get 24/7 support from Atlassian’s team of experts',
	'WacSignupForm.signupOfferingIncludesFeaturesPremiumJsmUpgradeBody':
		'Get a free 30-day trial of Jira Service Management Premium for unlimited agents, unlimited storage, and much more. Cancel anytime.',
	'WacSignupForm.signupOfferingIncludesFeaturesPremiumJsmBullet1Title':
		'Atlassian Intelligence (AI)',
	'WacSignupForm.signupOfferingIncludesFeaturesPremiumJsmBullet1Body':
		'Deliver exceptional service experiences with AI-powered ITSM capabilities',
	'WacSignupForm.signupOfferingIncludesFeaturesPremiumJsmBullet2Title':
		'Advanced incident management',
	'WacSignupForm.signupOfferingIncludesFeaturesPremiumJsmBullet2Body':
		'Automate your major incident creation process',
	'WacSignupForm.signupOfferingIncludesFeaturesPremiumJsmBullet3Title': 'Premium support',
	'WacSignupForm.signupOfferingIncludesFeaturesPremiumJsmBullet3Body':
		'Get 24/7 support from Atlassian’s team of experts',
	'WacSignupForm.signupOfferingIncludesFeaturesPremiumJswUpgradeBody':
		'Get a free 30-day trial of Jira Premium for unlimited users, unlimited storage, and much more. Cancel anytime.',
	'WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet1Title':
		'Atlassian Intelligence (AI)',
	'WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet1Body':
		'AI-powered features to help teams create value faster',
	'WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet2Title': 'Advanced planning',
	'WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet2Body':
		'Plan work and track progress across multiple teams and projects',
	'WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet3Title': 'Premium support',
	'WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet3Body':
		'Get 24/7 support from Atlassian’s team of experts',
	'WacSignupForm.bitbucketWorkspaceIdFieldLabelMessage': 'Workspace ID',
	'WacSignupForm.bitbucketOrganizationIdFieldLabelMessage': 'Organization',
	'WacSignupForm.bitbucketOrganizationIdFieldHelperMessage':
		"We'll create your workspace in this organization.",
	'WacSignupForm.bitbucketUnitPickerFieldLabelMessage': 'Unit',
	'WacSignupForm.bitbucketUnitPickerFieldHelperMessage':
		'Choose the unit that your workspace belongs to.',
	'WacSignupForm.bitbucketWorkspaceIdFieldHelperMessage':
		'The workspace ID can only contain lowercase letters, numbers, dashes, and underscores.',
	'WacSignupForm.bitbucketSubmitButtonTextMessage': 'Agree and create workspace',
	'WacSignupForm.bitbucketWorkspaceIdFieldErrorMessageCMT':
		'The workspace ID is invalid. Workspace IDs can only contain lowercase letters, numbers, dashes, and underscores.',
	'WacSignupForm.bitbucketWorkspaceIdTakenErrorMessageCMT':
		'This workspace ID is taken. Try another ID.',
	'WacSignupForm.bitbucketMissingOrgsInfoMessage':
		'If an organization is not listed in the dropdown menu, <a href="{supportUrl}" target="_blank">contact our Support team for assistance</a>.',
	'WacSignupForm.bitbucketCreateNewOrgInfoMessage':
		'We need to create a new Atlassian organization, because you currently do not have an organization in Atlassian\'s centralized user management. If you have any questions, <a href="{supportUrl}" target="_blank">contact our Support team for assistance</a>.',
	'WacSignupForm.bitbucketOrgCreationPreparingProductMessage': "We're preparing your product.",
	'WacSignupForm.bitbucketOrgCreationEstimatedTimeMessage':
		"This won't take more than a minute or two.",
	'WacSignupForm.productActivationFailureMessage':
		'<p>Something went wrong on our end. Please try again. If this keeps happening, <a href="https://support.atlassian.com/contact/">contact support</a>.</p>',
};
export const firstImpressionsImageUrls = {
	backgroundImage:
		'https://atlassian.com/dam/jcr:fa398d64-ddab-4e01-b3bf-90042efc7638/blue_wave_background.svg',
	jiraSoftware: {
		heroImage: 'https://atlassian.com/dam/jcr:0c7fa8be-146c-4c6f-84de-de9fb3b84674/Jira%20Hero.svg',
		socialProofImage:
			'https://atlassian.com/dam/jcr:37f44a00-1c5f-45e7-b3f5-a38ad08c46c1/jsw-social-proof-reel.svg',
	},
	jiraServiceDesk: {
		heroImage: 'https://atlassian.com/dam/jcr:45864a30-5470-4cbe-be59-9aae63492229/JSD%20Hero.svg',
		socialProofImage:
			'https://atlassian.com/dam/jcr:4bacc2d6-c0ff-4949-955e-50cde04a3898/jsm-social-proof-reel.svg',
	},
	confluence: {
		heroImage:
			'https://atlassian.com/dam/jcr:12b69d08-6ae8-4b14-ac1c-f3092ccaff97/Confluence%20Hero.svg',
		socialProofImage:
			'https://atlassian.com/dam/jcr:ed997381-ade2-440b-8374-7d2095bd7b38/confluence-social-proof-reel.svg',
	},
	jiraCore: {
		heroImage:
			'https://atlassian.com/dam/jcr:f00e5006-4d17-4565-bf8b-89a0867d4388/Jira%20Core%20Hero.svg',
		socialProofImage:
			'https://atlassian.com/dam/jcr:f2b4976d-a53a-42a0-93ec-def9b87fe654/jwm-social-proof-reel.svg',
	},
	teamCentral: {
		heroImage:
			'https://atlassian.com/dam/jcr:9991958d-3d80-45fd-9af0-c53d15270ec8/atlas-signup-hero.svg',
		socialProofImage:
			'https://atlassian.com/dam/jcr:80e875ca-274f-44fd-b1d3-50e47c43a73b/atlas-logo-real-448x60-N50.png',
	},
	jiraProductDiscovery: {
		heroImage:
			'https://atlassian.com/dam/jcr:7cfe6bed-77da-410b-8fcc-2c3f3f78cef5/jpd-hero-image-v3.svg',
		socialProofImage:
			'https://atlassian.com/dam/jcr:a8911809-1897-4fbc-9a7e-086e07e07199/jpd-social-proof-reel.svg',
	},
	compass: {
		heroImage:
			'https://atlassian.com/dam/jcr:ddb40094-3568-4eee-84fb-adfd5b20ca96/Compass_SignUpPage_Illo%20(5).svg',
		socialProofImage: '',
	},
	fabric: {
		heroImage:
			'https://atlassian.com/dam/jcr:978c45e6-3cf7-40d1-9a42-172cc8e77e60/fabric-sign-up-hero-rev@2x.png',
		socialProofImage: '',
	},
	beacon: {
		heroImage: 'https://atlassian.com/dam/jcr:f82f862b-5d6b-49ec-9d95-886664208834/beacon-hero.svg',
		socialProofImage: '',
	},
	jira: {
		heroImage:
			'https://atlassian.com/dam/jcr:775fdafc-0622-4a54-acdf-1c3ca0da5e83/jira-family-hero.png',
		socialProofImage:
			'https://atlassian.com/dam/jcr:37f44a00-1c5f-45e7-b3f5-a38ad08c46c1/jsw-social-proof-reel.svg',
	},
	bitbucket: {
		heroImage:
			'https://dam-cdn.atl.orangelogic.com/AssetLink/j6ow7g6d0b514p5fa2265brhf5hyn43l.webp',
		socialProofImage:
			'https://dam-cdn.atl.orangelogic.com/AssetLink/f21tl4w4krcqx1j1n5b100x1h176wy64.svg',
	},
};
